// @ts-nocheck
import {
  Package,
  ShoppingCart,
  CalendarDays,
  DollarSign,
  AlertTriangle,
  Percent,
  Clock,
  RefreshCw,
} from "lucide-react";

export const tabDefs = [
  { key: "overview", label: "Overview" },
  { key: "orders", label: "Orders" },
  { key: "inventory", label: "Inventory" },
  { key: "catalog", label: "Catalog" },
  { key: "sync", label: "Sync Logs" },
  { key: "revenue", label: "Revenue" },
  { key: "reports", label: "Reports" },
  { key: "notifications", label: "Notifications" },
  { key: "activity", label: "Activity Log" },
];

export const kpiDefs = [
  {
    key: "totalProducts",
    label: "Total Products",
    icon: Package,
    color: "indigo",
  },
  {
    key: "activeOrders",
    label: "Active Orders",
    icon: ShoppingCart,
    color: "emerald",
  },
  {
    key: "ordersToday",
    label: "Orders Today",
    icon: CalendarDays,
    color: "blue",
  },
  {
    key: "revenue30d",
    label: "Revenue (30d)",
    icon: DollarSign,
    color: "teal",
    fmt: "currency",
  },
  {
    key: "inventoryAlerts",
    label: "Inventory Alerts",
    icon: AlertTriangle,
    color: "amber",
  },
  {
    key: "syncFailures",
    label: "Sync Failures",
    icon: RefreshCw,
    color: "rose",
  },
  { key: "refundRate", label: "Refund Rate %", icon: Percent, color: "orange" },
  {
    key: "avgFulfillment",
    label: "Avg Fulfillment",
    icon: Clock,
    color: "slate",
  },
];

export const iconBg = {
  indigo:
    "bg-indigo-50 dark:bg-indigo-950 text-indigo-600 dark:text-indigo-400",
  emerald:
    "bg-emerald-50 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400",
  blue: "bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400",
  teal: "bg-teal-50 dark:bg-teal-950 text-teal-600 dark:text-teal-400",
  amber: "bg-amber-50 dark:bg-amber-950 text-amber-600 dark:text-amber-400",
  rose: "bg-rose-50 dark:bg-rose-950 text-rose-600 dark:text-rose-400",
  orange:
    "bg-orange-50 dark:bg-orange-950 text-orange-600 dark:text-orange-400",
  slate: "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400",
};
